// src/pages/admin/Settings/SettingsGeneral.js
import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select, Switch, message, Row, Col, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;
const { Title } = Typography;

const SettingsGeneral = ({ onLogout }) => { // Added onLogout prop
  const navigate = useNavigate();
  const [form] = Form.useForm();

  // Sample initial settings (replace with API fetch in production)
  const initialSettings = {
    siteName: 'JectHub',
    timezone: 'UTC',
    defaultLanguage: 'en',
    enableEmailNotifications: true,
    contactEmail: 'support@jecthub.com',
  };

  useEffect(() => {
    // Simulate fetching settings from an API
    form.setFieldsValue(initialSettings);

    // Placeholder for real API call
    /*
    fetch('/api/settings/general')
      .then((response) => response.json())
      .then((data) => {
        form.setFieldsValue(data);
      })
      .catch((error) => {
        console.error('Error fetching settings:', error);
      });
    */
  }, [form]);

  const handleSubmit = (values) => {
    // Placeholder: Update settings via API
    /*
    fetch('/api/settings/general', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(values),
    })
      .then((response) => response.json())
      .then(() => {
        message.success('General settings updated successfully');
      })
      .catch((error) => {
        console.error('Error updating settings:', error);
        message.error('Failed to update settings');
      });
    */
    console.log('Updated settings:', values);
    message.success('General settings updated successfully');
  };

  const timezoneOptions = [
    { label: 'UTC', value: 'UTC' },
    { label: 'EST (UTC-5)', value: 'America/New_York' },
    { label: 'PST (UTC-8)', value: 'America/Los_Angeles' },
    { label: 'GMT+1', value: 'Europe/London' },
    { label: 'IST (UTC+5:30)', value: 'Asia/Kolkata' },
  ];

  const languageOptions = [
    { label: 'English', value: 'en' },
    { label: 'Spanish', value: 'es' },
    { label: 'French', value: 'fr' },
    { label: 'German', value: 'de' },
  ];

  return (
    <div style={{ padding: '24px', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
      <Title level={2} style={{ marginBottom: 16 }}>General Settings</Title>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={initialSettings}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="siteName"
              label="Site Name"
              rules={[{ required: true, message: 'Please enter the site name' }]}
            >
              <Input placeholder="Enter site name" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="timezone"
              label="Timezone"
              rules={[{ required: true, message: 'Please select a timezone' }]}
            >
              <Select placeholder="Select timezone">
                {timezoneOptions.map((tz) => (
                  <Option key={tz.value} value={tz.value}>
                    {tz.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="defaultLanguage"
              label="Default Language"
              rules={[{ required: true, message: 'Please select a default language' }]}
            >
              <Select placeholder="Select default language">
                {languageOptions.map((lang) => (
                  <Option key={lang.value} value={lang.value}>
                    {lang.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="contactEmail"
              label="Contact Email"
              rules={[
                { required: true, message: 'Please enter the contact email' },
                { type: 'email', message: 'Please enter a valid email' },
              ]}
            >
              <Input placeholder="Enter contact email" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="enableEmailNotifications"
              label="Enable Email Notifications"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save Settings
          </Button>
          <Button style={{ marginLeft: 8 }} onClick={() => form.resetFields()}>
            Reset
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default SettingsGeneral;